import { render, staticRenderFns } from "./pmmeasurefs.vue?vue&type=template&id=5dda4fe1"
import script from "./pmmeasurefs.vue?vue&type=script&lang=js"
export * from "./pmmeasurefs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./pmmeasurefs.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports